import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import {
  CompanyName,
  LocationCity,
  LocationCountry,
  MainTitle,
  SubtitleMain,
} from '../../utils/Constants';
import {
  COMMERCIALS_PAGE_URL,
  CONTACT_PAGE_URL,
  WELLNESS_PAGE_URL,
} from '../../utils/Routes';
// Images
import MainImage from '../../assets/images/people/siv-renate-body-building.webp';
import SecondImage from '../../assets/images/people/siv-renate-photo.webp';


function AboutPageHeader() {
  return (
    <header className='grid min-h-screen pt-[84px] w-full h-full overflow-x-hidden'>
      {/* Phone */}
      <section className='grid lg:hidden px-8 py-4 w-full'>
        <article className='grid justify-center'>
          <div className='grid h-fit gap-y-8 text-center'>
            <h1
              className='font-agraham text-4xl w-full text-colour5 tracking-wide'
              style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.6)' }}
            >
              About Me
            </h1>
            <div className='text-base font-titleFont text-center px-8'>
              <h2>{MainTitle}</h2>
            </div>
          </div>

          <div className='grid justify-center'>
            <img
              src={SecondImage}
              alt={`${CompanyName} fitness header`}
              className='max-w-xs border_special'
            />
          </div>

          <div className='text-center text-lg'>
            <p>
              Creating commercials, media editing and offering classes and
              advice in body and mental wellness.
            </p>
          </div>

          {/* Cta */}
          <section className='grid grid-cols-3 gap-x-2 w-full justify-between text-center'>
            <Link
              to={WELLNESS_PAGE_URL}
              className='text-colour5 underline hover:brightness-75 text-center'
            >
              Wellness
            </Link>
            <Link
              to={COMMERCIALS_PAGE_URL}
              className='text-colour5 underline hover:brightness-75 text-center'
            >
              Commercials
            </Link>
            <Link
              to={CONTACT_PAGE_URL}
              className='text-colour5 underline hover:brightness-75 text-center'
            >
              Contact
            </Link>
          </section>
        </article>
      </section>

      {/* Large screen */}
      <section className='hidden relative lg:grid w-full'>
        {/* LEFT rail */}
        <div className='absolute inset-y-0 left-0 w-12 z-20 grid place-items-center'>
          <span className='[writing-mode:vertical-rl] rotate-180 [text-orientation:mixed] underline underline-offset-4'>
            From {LocationCity}, {LocationCountry}
          </span>
        </div>

        {/* RIGHT rail */}
        <div className='absolute inset-y-0 right-0 w-12 z-20 grid place-items-center'>
          <span className='[writing-mode:vertical-rl] rotate-180 [text-orientation:mixed] underline underline-offset-4'>
            {SubtitleMain}
          </span>
        </div>

        <div className='grid relative w-full h-full px-8'>
          <img
            src={SecondImage}
            alt={`${CompanyName} fitness header`}
            className='absolute grid items-center w-full z-10 transform -translate-x-1/2 h-auto max-w-sm top-[6rem] right-44 border_special'
          />
          <img
            src={MainImage}
            alt={`${CompanyName} fitness header`}
            className='absolute grid items-center w-full transform h-auto max-w-sm top-[1rem] -translate-y-0 right-24 border_special'
          />
        </div>

        <article className='grid w-full h-full pt-16 grid-rows-reg z-20'>
          <section className='relative px-12 pl-20'>
            <div className='hidden lg:block absolute text-xl font-titleFont -top-[3rem] text-left'>
              <h2 className='text-sm'>{MainTitle}</h2>
            </div>
            <h1
              className='font-agraham text-[5.5rem] 2xl:text-[8rem] w-full text-colour5 tracking-wide'
              style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.6)' }}
            >
              About Me
            </h1>
          </section>
          <section className='grid w-full px-12'>
            <div className='grid h-fit grid-cols-rev pr-8 pt-8 pl-20'>
              <div className='grid items-center text-center'>
                <p className='text-sm xl:text-base max-w-[50vw]'>
                  My passion is blending creativity with care — producing
                  commercials that inspire, while guiding others toward balance
                  and well-being through wellness coaching.
                </p>
              </div>
            </div>
            <section className='grid items-end py-6'>
              <div className='grid h-fit grid-cols-2 '>
                <div className='grid items-center'>
                  <div className='h-[2px] w-full bg-colour5'></div>
                </div>

                <section className='grid grid-cols-3 text-lg font-semibold gap-x-2 w-full justify-center text-center'>
                  <Link
                    to={WELLNESS_PAGE_URL}
                    className='text-colour5 underline hover:brightness-75 text-center'
                    aria-label='Learn more about wellness coaching with Siv Renate'
                    title='Wellness coaching by Siv Renate — available worldwide'
                  >
                    Wellness
                  </Link>

                  <Link
                    to={COMMERCIALS_PAGE_URL}
                    className='text-colour5 underline hover:brightness-75 text-center'
                    aria-label='View Siv Renate’s commercials and UGC portfolio'
                    title='Commercials and UGC portfolio by Siv Renate'
                  >
                    Commercials
                  </Link>

                  <Link
                    to={CONTACT_PAGE_URL}
                    className='text-colour5 underline hover:brightness-75 text-center'
                    aria-label='Get in touch with Siv Renate'
                    title='Contact Siv Renate for inquiries, bookings, or collaborations'
                  >
                    Contact
                  </Link>
                </section>
              </div>
            </section>
          </section>
        </article>
      </section>
    </header>
  );
}

export default AboutPageHeader;
